/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { i as isObject_1 } from '../../_chunks/dep-88cd50bf.js';
import { isEnabledDate } from '../../_common/js/date-picker/utils.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-46de7b2e.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import 'dayjs';
import '../../_chunks/dep-fdce1f4f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-6506fbc2.js';

function useDisableDate(props) {
  var _disableDate = props.disableDate,
    format = props.format,
    mode = props.mode,
    start = props.start,
    end = props.end;
  return {
    disableDate: function disableDate(value) {
      return !isEnabledDate({
        disableDate: _disableDate,
        format: format,
        mode: mode,
        value: value
      });
    },
    minDate: isObject_1(_disableDate) && "before" in _disableDate ? new Date(_disableDate.before) : start,
    maxDate: isObject_1(_disableDate) && "after" in _disableDate ? new Date(_disableDate.after) : end
  };
}

export { useDisableDate as default };
//# sourceMappingURL=useDisableDate.js.map
